<template>
  <v-dialog v-model="dialog" max-width="500">
    <template v-slot:activator="{ on, attrs }">
      <v-btn outlined block color="error" v-bind="attrs" v-on="on">{{
        $t('btn_cancel_order')
      }}</v-btn>
    </template>
    <v-card>
      <v-card-title>
        <span class="text-h6 primary--text">
          {{ $t('title_cap_cancel_order') }}
        </span>
      </v-card-title>
      <v-card-subtitle class="pt-2 pt-md-4">
        <span>
          {{ $t('cap_cancel_order_info') }}
        </span>
      </v-card-subtitle>
      <v-card-text>
        <v-form ref="form" @submit.prevent>
          <v-row no-gutters>
            <v-col cols="12" sm="12">
              <v-select
                v-model="cancel.reason"
                label="Choose Reason"
                :items="items"
                item-text="text"
                item-value="value"
                return-object
                outlined
                :rules="[(v) => !!v || 'Reason is required']"
              ></v-select>
            </v-col>
            <v-col cols="12" sm="12">
              <v-textarea
                v-model="cancel.desc"
                :label="$t('cap_form_create_prod_desc')"
                filled
                outlined
                auto-grow
                :rules="descRule"
              ></v-textarea>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-btn text class="primary--text" @click="onCancel">
          {{ $t('btn_txt_cancel') }}
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn outlined color="error" @click="onSubmit">
          {{ $t('btn_cap_save') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'CassOrderCancel',
  props: {
    documentId: {
      type: String,
      default: 'EhE7o1faLNMEu0GOPevu'
    }
  },
  data() {
    return {
      dialog: false,
      cancel: {
        reason: '',
        desc: ''
      }
    }
  },
  computed: {
    items() {
      return [
        { text: this.$t('cap_cancel_order_001'), value: 'spam' },
        { text: this.$t('cap_cancel_order_002'), value: 'out of stock' },
        { text: this.$t('cap_cancel_order_003'), value: 'address unreachable' },
        {
          text: this.$t('cap_cancel_order_004'),
          value: 'delivery unavailable'
        },
        { text: this.$t('cap_cancel_order_005'), value: 'others' }
      ]
    },
    descRule() {
      return [
        (v) => {
          if (this.cancel.reason.value === 'others') {
            return !!v || 'Description is Required'
          } else {
            return true
          }
        }
      ]
    }
  },
  methods: {
    onCancel() {
      this.dialog = false
      this.cancel = {
        reason: '',
        desc: ''
      }
      this.$refs.form.resetValidation()
    },
    onSubmit() {
      if (this.$refs.form.validate()) {
        // eslint-disable-next-line
        console.log(
          `OrderId ${this.documentId} is cancelled. Reason: ${this.cancel.reason.value}`
        )
        const payload = {
          documentId: this.documentId,
          cancel: {
            reason: this.cancel.reason.value,
            desc: this.cancel.desc
          }
        }
        this.$store
          .dispatch('order/cancelOrder', payload)
          .then(() => {
            this.dialog = false
            this.$router.push({ name: 'Order' })
          })
          .catch((error) => {
            // eslint-disable-next-line
            console.log(error)
          })
      }
    }
  }
}
</script>
